import { render } from "./App.vue?vue&type=template&id=f41b542c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f41b542c&lang=scss"
import "./App.vue?vue&type=style&index=1&id=f41b542c&lang=css"
import "./App.vue?vue&type=style&index=2&id=f41b542c&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__